module.exports = __webpack_public_path__ + "img/creditbg_text.6e437d14.png";